module.exports = "./img/6e867092f771db17288e3c4098da2e5d.jpg";